import CollapsiblePanel from './CollapsiblePanel.component';

export default CollapsiblePanel;
